
import React from "react";

/**
 * Reduced personal note – no redundant quote,
 * just a quiet, confident closing before CTA
 */
const PersonalNoteSection = () => {
  return (
    <section className="py-16 md:py-20 bg-muted/30">
      <div className="container max-w-3xl mx-auto px-4 text-center">
        <div className="flex flex-col items-center">
          <div className="w-20 h-20 rounded-full overflow-hidden mb-6 border-2 border-background shadow-sm">
            <img 
              src="/lovable-uploads/21de3789-ed78-4fd4-9bae-abb205041b23.png" 
              alt="Jörg Hörmann" 
              className="w-full h-full object-cover object-top"
            />
          </div>
          <p className="text-muted-foreground leading-relaxed max-w-xl">
            Was mich antreibt? Der Moment, in dem Menschen erkennen, dass sie selbst die Kraft zur 
            Veränderung in sich tragen. Ich bin nicht hier, um zu führen, sondern um zu ermöglichen.
          </p>
          <p className="text-sm text-muted-foreground mt-4">
            Jörg Hörmann
          </p>
        </div>
      </div>
    </section>
  );
};

export default PersonalNoteSection;
